export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14033.2e344c30.jpg";